Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default=function(ctx) {
var __t, __p = '';
__p += '<img style="width: 100%;" ref="signatureImage">\n';
return __p
}


//////////////////
// WEBPACK FOOTER
// ./~/formiojs/templates/bootstrap/signature/html.ejs.js
// module id = 3306
// module chunks = 0